import React, { useState } from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import {
  ReportFilterOptions,
  ReportType,
  RevenueAndProfitChartData,
} from 'utils/apiClient/services/reports/types';
import RevenueAndProfitChart from './views/RevenueOverviewRevenueAndProfitChartView';
import ReportCard from './views/ReportCard';
import ReportTypeSelect from './views/ReportTypeSelect';

type Props = {
  options?: ReportFilterOptions;
  data: Array<RevenueAndProfitChartData>;
  currency: string;
  loading: boolean;
  changeReportType: (report: ReportType) => void;
};

const SelectWrapper = styled.div`
  position: absolute;
  z-index: 99;
  right: 20px;
  top: 10px;
`;

const RevenueOverviewRevenueAndProfitChart: React.FC<Props> = ({
  data,
  options,
  currency,
  loading,
  changeReportType,
}) => {
  const [internalOptions, setInternalOptions] =
    useState<ReportFilterOptions>(options);

  const changeType = (type: ReportType) => {
    const first = internalOptions.dateRange?.[0];
    const end = internalOptions.dateRange?.[1];
    if (first && end && dayjs(first).add(49, 'days').isBefore(end)) {
      setInternalOptions({ ...internalOptions, type });
    } else {
      setInternalOptions((opt) => ({ ...opt, type }));
    }
    changeReportType(type);
  };

  return (
    <ReportCard
      styles={{
        header: {
          textTransform: 'initial',
        },
        body: {
          padding: 10,
          height: 275,
        },
      }}
    >
      {internalOptions && (
        <SelectWrapper>
          <ReportTypeSelect
            value={internalOptions?.type ?? ReportType.Daily}
            handleChange={changeType}
          />
        </SelectWrapper>
      )}
      <RevenueAndProfitChart
        isDataLoading={loading}
        currency={currency}
        data={data ?? []}
      />
    </ReportCard>
  );
};

export default RevenueOverviewRevenueAndProfitChart;
